var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCylinder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_125_763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 557",
    d: "M4.53593 6.63679L1.07178 4.35943V12.2179L1.84159 13.8217L4.72838 15.0406L8.35291 15.65L12.1378 15.0406L14.7359 12.7632V4.35943L11.6888 6.63679L8.16046 7.05377L4.53593 6.63679Z",
    fill: "#95E3FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 556",
    d: "M2.37493 2.20071L1.53916 3.36572C1.46551 3.4684 1.43346 3.59515 1.44946 3.72049L1.58502 4.78243C1.60514 4.94001 1.69893 5.07864 1.83771 5.15594L4.07203 6.40037C4.12424 6.42945 4.18123 6.44893 4.24032 6.45789L8.70846 7.13582C8.77022 7.14519 8.83319 7.1429 8.8941 7.12908L12.4932 6.31248C12.5757 6.29377 12.652 6.25447 12.7151 6.19825L14.4275 4.67315C14.5759 4.54103 14.6319 4.33362 14.5703 4.14476L14.248 3.15625C14.211 3.04265 14.1345 2.94606 14.0324 2.884L11.0386 1.06425C10.9603 1.01667 10.8705 0.991508 10.7789 0.991508H6.90511C6.86539 0.991508 6.82581 0.996242 6.78721 1.00561L2.6633 2.00626C2.54701 2.03448 2.44469 2.10347 2.37493 2.20071Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 72",
    d: "M14.7679 12.0294C14.7679 13.8818 11.7378 15.3834 7.99998 15.3834C4.26216 15.3834 1.23206 13.8818 1.23206 12.0294",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 74",
    d: "M14.7491 3.75495C14.7491 4.45323 14.1642 5.2226 12.9039 5.8472C11.6747 6.45633 9.94163 6.8474 8.00003 6.8474C6.05844 6.8474 4.32535 6.45633 3.0962 5.8472C1.83586 5.2226 1.25098 4.45323 1.25098 3.75495C1.25098 3.05668 1.83586 2.2873 3.0962 1.66271C4.32535 1.05357 6.05844 0.662498 8.00003 0.662498C9.94163 0.662498 11.6747 1.05357 12.9039 1.66271C14.1642 2.2873 14.7491 3.05668 14.7491 3.75495Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 312",
    d: "M1.23206 3.88425V12.1587",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 313",
    d: "M14.7679 3.75495V12.0294",
    stroke: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCylinder);
export default __webpack_public_path__ + "static/media/cylinder.1f9091328ae7203e50218b8e854434cb.svg";
export { ForwardRef as ReactComponent };